var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTaglioAutomaticoYellowGreen(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-994 4273)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M85.717,98.113a7.552,7.552,0,0,0,.9,1.129l-2.153,2.086a10.465,10.465,0,0,0,6.524,3.147l.289-2.986c.238.023.479.037.722.037s.485-.014.723-.037l.289,2.986a10.452,10.452,0,0,0,6.417-3.046L84.6,86.6a10.453,10.453,0,0,0-2.561,4.113l2.846.946a7.478,7.478,0,0,0-.319,1.408L81.6,92.687a10.55,10.55,0,0,0-.1,1.339,10.44,10.44,0,0,0,1.7,5.722Z",
    transform: "translate(914 -4355)",
    fill: "#fa0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.432,93.069a7.46,7.46,0,0,0-.319-1.408l2.846-.946a10.514,10.514,0,0,0-4.519-5.658l-1.555,2.562a7.454,7.454,0,0,0-1.3-.627l1.034-2.813a10.343,10.343,0,0,0-7.239,0l1.034,2.813a7.454,7.454,0,0,0-1.3.627L86.56,85.057A10.586,10.586,0,0,0,84.6,86.6l14.828,14.828c.034-.035.072-.066.106-.1l-2.153-2.086a7.544,7.544,0,0,0,.9-1.128l2.513,1.634a10.435,10.435,0,0,0,1.7-5.722,10.547,10.547,0,0,0-.1-1.338Z",
    transform: "translate(914 -4355)",
    fill: "#16b240"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.283,98.113a7.552,7.552,0,0,1-.9,1.129l2.153,2.086a10.465,10.465,0,0,1-6.524,3.147l-.289-2.986c-.238.023-.479.037-.722.037s-.485-.014-.723-.037l-.289,2.986a10.465,10.465,0,0,1-6.524-3.147l2.153-2.086a7.552,7.552,0,0,1-.9-1.129L83.2,99.748a10.439,10.439,0,0,1-1.7-5.722,10.55,10.55,0,0,1,.094-1.339l2.973.382a7.478,7.478,0,0,1,.319-1.408l-2.846-.946a10.522,10.522,0,0,1,4.519-5.658l1.555,2.563a7.454,7.454,0,0,1,1.3-.627L88.38,84.18a10.343,10.343,0,0,1,7.239,0l-1.034,2.813a7.454,7.454,0,0,1,1.3.627l1.555-2.563a10.518,10.518,0,0,1,4.519,5.658l-2.846.946a7.478,7.478,0,0,1,.319,1.408l2.973-.382a10.55,10.55,0,0,1,.1,1.339,10.44,10.44,0,0,1-1.7,5.722Z",
    transform: "translate(914 -4355)",
    fill: "none",
    stroke: "#202020",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.481,95.605H90.508l-.622,1.787H88.5l2.9-7.674h1.2l2.9,7.674H94.108Zm-2.6-1.075h2.224l-1.112-3.184Z",
    transform: "translate(914 -4355)",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    transform: "translate(994 -4273)",
    fill: "none"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTaglioAutomaticoYellowGreen);
export default __webpack_public_path__ + "static/media/taglio_automatico_yellow_green.e8975f901ddb0ffa7b05a3a8d2c9a098.svg";
export { ForwardRef as ReactComponent };